<template>
  <div :class="['totas']">
    <div class="totas-box" v-if="status === 1">
      <!-- <img class="totas-img" src="https://mediakit.enabot.com/eboX/img/mobile/alert_email_success@2x.png" alt=""> -->
      <img class="totas-icon" src="@/assets/common/alert_email_success_icon.png" alt="">
      <div class="totas-title1">Thanks for signing up!</div>
      <img class="totas-code-icon" src="https://mediakit.enabot.com/eboX/img/common/totas_code_icon.png" alt="">
      <!-- <p class="totas-p1">Thank you for your love and support.</p> -->
    </div>
    <div class="totas-box" v-else-if="status === 2">
      <!-- <img class="totas-img" src="https://mediakit.enabot.com/eboX/img/mobile/alert_email_repeat@2x.png" alt=""> -->
      <img class="totas-icon" src="@/assets/common/alert_email_success_icon.png" alt="">
      <div class="totas-title2">You are already subscribed with this email address!</div>
      <img class="totas-code-icon" src="https://mediakit.enabot.com/eboX/img/common/totas_code_icon.png" alt="">
      <!-- <p class="totas-p2">Thank you for your love and support.</p> -->
    </div>
    <div class="totas-box" v-else-if="status === 3">
      <!-- <img class="totas-img" src="https://mediakit.enabot.com/eboX/img/mobile/alert_email_null@2x.png" alt=""> -->
      <img  class="totas-icon" src="@/assets/common/alert_email_null_icon.png" alt="">
      <div  class="totas-title3">Please enter your email!</div>
      <img class="totas-code-icon" src="https://mediakit.enabot.com/eboX/img/common/totas_code_icon.png" alt="">
      <!-- <p class="totas-p3">Thank you for your love and support.</p> -->
    </div>
    <div class="totas-box" v-else-if="status === 4">
      <!-- <img class="totas-img" src="https://mediakit.enabot.com/eboX/img/mobile/alert_email_error@2x.png" alt=""> -->
      <img class="totas-icon" src="@/assets/common/alert_email_error_icon.png" alt="">
      <div class="totas-title4">Please enter a valid email address!</div>
      <img class="totas-code-icon" src="https://mediakit.enabot.com/eboX/img/common/totas_code_icon.png" alt="">
      <!-- <p class="totas-p4">Thank you for your love and support.</p> -->
    </div>
    <!-- <div @click="handleClose" class="totas-button-wrap">
      <img class="totas-button" src="https://mediakit.enabot.com/eboX/img/mobile/alert_email_button@2x.png" alt="">
      <span class="totas-button-span">close</span>
    </div> -->
    <div class="totas-button-close-wrap">
      <button @click="GoURL" class="totas-button-close">Join EBO X Group</button>
    </div>
    
    
    <img @click="handleClose" class="totas-close" src="https://mediakit.enabot.com/eboX/img/mobile/alert_email_close@2x.png" alt="">
  </div>
</template>

<script>
export default {
  props: {
    status:{
      type:Number,
      default:1
    }
  },
  methods: {
    handleClose(){
      this.$emit('handleClose')
    },
    GoURL(){
      window.location.href="https://www.facebook.com/groups/3167832886862481/?ref=share&mibextid=S66gvF";
    }
  },
}
</script>

<style lang="scss" scoped>
.totas{
  color: #fff;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  // transition: 0.6s linear;
  width: 292px;
  z-index: 9999;
  border-radius: 10px;
  background-color: #fff;
  .totas-img{
    width: 292px;
    height: auto;
  }
  
  .totas-button-wrap{
    position: absolute;
    bottom: 42px;
    left: 50%;
    width: 35.9%;
    height: auto;
    transform: translateX(-50%);
    cursor: pointer;
  }
  .totas-button{
    width: 100%;
    height: auto;
  }
  .totas-box{
    text-align: center;
    padding: 30px 0px 8px;
  }
  .totas-icon{
    width: 30px;
    height: 30px;
    margin: 0 auto;
  }
  .totas-code-icon{
    width: 60px;
    height: 60px;
    margin: 0 auto;
  }
  .totas-title1,.totas-title2,.totas-title3,.totas-title4{
    color: #000;
    font-size: 15px;
    line-height: 18px;
    width: 76%;
    margin: 6px auto 8px;
  }
  .totas-p1,.totas-p2,.totas-p3,.totas-p4{
    padding-top: 0px;
    color: RGBA(165, 164, 164, 1);
    // color: RGBA(205, 205, 205, 1);
    font-size: 12px;
    line-height: 12px;
    transform: scale(0.9);
  }
  .totas-button-close-wrap{
    padding-bottom: 30px;
  }
  .totas-button-close{
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    line-height: 27px;
    border-radius: 4px;
    width: 105px;
    // padding: 10px 0 8px 0;
    background-color: RGBA(80, 200, 255, 1);
  }
  .totas-button-span{
    // position: absolute;
    // left: 50%;
    // top: 50%;
    // transform: translate(-50%, -50%);
    color: rgba(255, 255, 255, 0.7);
    font-size: 12px;
  }
  .totas-close{
    position: absolute;
    width: 10px;
    height: 10px;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }
}
</style>